import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import type { User, AppId } from '@homeapp/shared';

interface AuthContextType {
  user: (User & { access: AppId[] }) | null;
  token: string | null;
  loading: boolean;
  mustChangePassword: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  setPasswordChanged: () => void;
  updateUser: (user: User & { access: AppId[] }) => void;
}

export function useAuth(): AuthContextType {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
